import { FC } from 'react'
import { Form, Button, InputNumber, Row, Col, Flex, Alert } from 'antd'
import { PlusOutlined, MinusCircleOutlined } from '@ant-design/icons'
import User from '../user/user'
import { requiredInputNumberRules } from '../../../constants/forms/validation/rules'

interface CuratorsFieldProps {
    disabled?: boolean
}

const CuratorsField: FC<CuratorsFieldProps> = ({ disabled }) => {
    return (
        <Form.List
            name='curators'
            rules={[
                {
                    validator: async (_, curators) => {
                        if (!curators || curators.length === 0) {
                            return Promise.reject(new Error('Добавьте минимум одного куратора'))
                        }
                    
                        const total = (curators as { percent?: number }[]).reduce(
                            (sum, curator) => sum + (Number(curator?.percent) || 0),
                            0
                        )
                    
                        if (total > 3.5) {
                            return Promise.reject(
                                new Error('Сумма процентов всех кураторов не должна превышать 3.5%')
                            )
                        }
                    
                        return Promise.resolve()
                    }
                },
            ]}
        >
            {(fields, { add, remove }, meta) => (
                <>
                    {meta.errors.map((error) => (
                        <Alert message={error} type='error' style={{ marginBottom: 16 }} />
                    ))}
                    <Row gutter={[24, 24]}>
                        {fields.map(({ key, name, ...restField }) => (
                            <Col xs={24} sm={6} key={key}>
                                <div
                                    style={{
                                        border: '1px solid #d9d9d9',
                                        borderRadius: 6,
                                        padding: 16,
                                    }}
                                >
                                    <Flex
                                        style={{ marginBottom: 8 }}
                                        justify='space-between'
                                        align='center'
                                    >
                                        <span style={{ fontWeight: 500 }}>Куратор {name + 1}</span>
                                        <MinusCircleOutlined
                                            onClick={() => !disabled && remove(name)}
                                            style={{
                                                color: '#ff4d4f',
                                                cursor: disabled ? 'not-allowed' : 'pointer',
                                            }}
                                        />
                                    </Flex>

                                    <Row gutter={16} align='bottom'>
                                        <Col xs={24} sm={16}>
                                            <User
                                                {...restField}
                                                name={[name, 'user']}
                                                label='Менеджер-куратор'
                                                placeholder='Выберите куратора'
                                                positions={['Менеджер', 'Помощник менеджера']}
                                            />
                                        </Col>
                                        <Col xs={24} sm={8}>
                                            <Form.Item
                                                {...restField}
                                                label='Процент'
                                                name={[name, 'percent']}
                                                rules={requiredInputNumberRules}
                                            >
                                                <InputNumber
                                                    placeholder='%'
                                                    disabled={disabled}
                                                    min={0}
                                                    max={3.5}
                                                    step={0.5}
                                                    style={{ width: '100%' }}
                                                />
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        ))}
                        <Col xs={24} sm={6}>
                            <Form.Item>
                                <Button
                                    type='dashed'
                                    onClick={() => add()}
                                    icon={<PlusOutlined />}
                                    block
                                    disabled={disabled}
                                >
                                    Добавить куратора
                                </Button>
                            </Form.Item>
                        </Col>
                    </Row>
                </>
            )}
        </Form.List>
    )
}

export default CuratorsField
